import * as React from "react";

const Twitter: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <path
                d="M32 0v32H0V0h32zM19.848 7.872a4.107 4.107 0 0 0-4.104 4.104c0 .32.04.632.104.936a11.649 11.649 0 0 1-8.456-4.288 4.113 4.113 0 0 0 1.272 5.48 4.15 4.15 0 0 1-1.856-.512v.056a4.11 4.11 0 0 0 3.288 4.024 4 4 0 0 1-1.08.144c-.264 0-.52-.024-.768-.072a4.102 4.102 0 0 0 3.832 2.848 8.228 8.228 0 0 1-5.096 1.76c-.328 0-.656-.016-.976-.056a11.669 11.669 0 0 0 6.28 1.832c7.544 0 11.672-6.256 11.672-11.672 0-.176 0-.352-.008-.528A8.357 8.357 0 0 0 26 9.8a8.314 8.314 0 0 1-2.36.648 4.127 4.127 0 0 0 1.808-2.272 8.16 8.16 0 0 1-2.608.992 4.095 4.095 0 0 0-2.992-1.296z"
                fill="#2E5996"
                fillRule="nonzero"
            />
        </svg>
    );
};

export default React.memo(Twitter);
